/**
 * @deprecated
 *
 * Mantido apenas para não quebrar testes de fluxos legados
 * NÃO adicioná-lo no objeto que mapeia os temas do projeto
 */

import * as Tokens from '@wisereducacao-npm/design-system-tokens/dist/esm/wol/dark/dark';
import {
  border,
  font as globalFontStyles,
  lineHeight,
  opacity,
  spacing,
} from '../global';

const color = {
  primary: {
    dark: Tokens.ColorPrimaryDark,
    light: Tokens.ColorPrimaryLight,
    medium: Tokens.ColorPrimaryMedium,
    pure: Tokens.ColorPrimaryPure,
  },
  secondary: {
    dark: Tokens.ColorSecondaryDark,
    light: Tokens.ColorSecondaryLight,
    medium: Tokens.ColorSecondaryMedium,
    pure: Tokens.ColorSecondaryPure,
  },
  neutral: {
    button: Tokens.NeutralColorButton,
    highContrast: Tokens.NeutralColorHighContrast,
    lowContrast: Tokens.NeutralColorLowContrast,
    mediumContrast: Tokens.NeutralColorMediumContrast,
    pure: Tokens.NeutralColorPure,
  },
  feedback: {
    success: {
      highContrast: Tokens.FeedbackColorSuccessHighContrast,
      lowContrast: Tokens.FeedbackColorSuccessLowContrast,
      mediumContrast: Tokens.FeedbackColorSuccessMediumContrast,
      pure: Tokens.FeedbackColorSuccessPure,
    },
    alert: {
      highContrast: Tokens.FeedbackColorAlertHighContrast,
      lowContrast: Tokens.FeedbackColorAlertLowContrast,
      mediumContrast: Tokens.FeedbackColorAlertMediumContrast,
      pure: Tokens.FeedbackColorAlertPure,
    },
    error: {
      highContrast: Tokens.FeedbackColorErrorHighContrast,
      lowContrast: Tokens.FeedbackColorErrorLowContrast,
      mediumContrast: Tokens.FeedbackColorErrorMediumContrast,
      pure: Tokens.FeedbackColorErrorPure,
    },
    button: Tokens.FeedbackColorButton,
  },
};

const font = {
  ...globalFontStyles,
  family: {
    primary: Tokens.FontFamilyPrimary,
  },
};

export const wol = {
  color,
  spacing,
  font,
  lineHeight,
  border,
  opacity,
  data: {
    dsProductId: 'wol',
    googleTagManagerId: 'GTM-KD85DXP',
    lang: 'pt-BR',
    faqLink: 'https://wiseup.com/faq/',
    refererArray: [
      {
        name: 'Site Wise Up',
        id: 'wiseup-site',
        datacy: '@success/sitewiseup-button',
      },
      {
        name: 'Escola Wise Up',
        id: 'wiseup-escola',
        datacy: '@sucess/escolawiseup-button',
      },
      { name: 'Email', id: 'email', datacy: '@success/email-button' },
      { name: 'Facebook', id: 'facebook', datacy: '@sucess/facebook-button' },
      { name: 'Google', id: 'google', datacy: '@sucess/google-button' },
      {
        name: 'Instagram',
        id: 'instagram',
        datacy: '@sucess/instagram-button',
      },
      { name: 'Youtube', id: 'youtube', datacy: '@sucess/youtube-button' },
      {
        name: 'Através de um representante',
        id: 'representante',
        datacy: '@sucess/representative-button',
      },
      {
        name: 'Adriana e Rodrigão',
        id: 'adrianaerodrigao',
        datacy: '@sucess/adrianaerodrigao-button',
      },
      {
        name: 'Flávio Augusto',
        id: 'flavioaugusto',
        datacy: '@sucess/flavioaugusto-button',
      },
      {
        name: 'Jovem Nerd',
        id: 'jovemnerd',
        datacy: '@sucess/jovemnerd-button',
      },
      {
        name: 'Thiago Nigro',
        id: 'thiagonigro',
        datacy: '@sucess/thiagonigro-button',
      },
      {
        name: 'Livelo',
        id: 'livelo',
        datacy: '@sucess/livelo-button',
      },
      { name: 'Outro', id: 'outro', datacy: '@sucess/outro-button' },
    ],
    product: {
      name: 'Wise Up Online',
      plans: {
        anualProductId: 'ff8de6bd-899f-424d-a5a8-4d5f2faef794',
        monthlyProductId: '',
      },
      price: {
        productCyclePrice: 156,
        productFullPrice: 1872,
        productStandardCycle: 156,
        productStandardPrice: 1872,
      },
    },
    payment: {
      methods: {
        creditcard: {
          active: true,
          name: 'Cartão de Crédito',
          planId: {
            test: 'ff8de6bd-899f-424d-a5a8-4d5f2faef794',
            homolog: 'ff8de6bd-899f-424d-a5a8-4d5f2faef794',
            production: 'ff8de6bd-899f-424d-a5a8-4d5f2faef794',
          },
        },
        debitcard: {
          active: false,
          name: 'Cartão de Débito',
          planId: {
            test: '',
            homolog: '',
            production: '',
          },
        },
        boleto: {
          active: false,
          name: 'Boleto Bancário',
          planId: {
            test: '99d3f7f1-500f-45d2-adb1-35de2d25fe54',
            homolog: '99d3f7f1-500f-45d2-adb1-35de2d25fe54',
            production: '99d3f7f1-500f-45d2-adb1-35de2d25fe54',
          },
        },
      },
      hasInstallments: false,
      installments: [],
      cardCompanies: [
        { value: 'american_express', name: 'Amex' },
        { value: 'visa', name: 'Visa' },
        { value: 'mastercard', name: 'Mastercard' },

        { value: 'elo', name: 'Elo' },
        { value: 'diners', name: 'Diners' },
      ],
      states: [
        { value: 'AC', name: 'AC' },
        { value: 'AL', name: 'AL' },
        { value: 'AP', name: 'AP' },
        { value: 'AM', name: 'AM' },
        { value: 'BA', name: 'BA' },
        { value: 'CE', name: 'CE' },
        { value: 'DF', name: 'DF' },
        { value: 'ES', name: 'ES' },
        { value: 'GO', name: 'GO' },
        { value: 'MA', name: 'MA' },
        { value: 'MT', name: 'MT' },
        { value: 'MS', name: 'MS' },
        { value: 'MG', name: 'MG' },
        { value: 'PA', name: 'PA' },
        { value: 'PB', name: 'PB' },
        { value: 'PR', name: 'PR' },
        { value: 'PE', name: 'PE' },
        { value: 'PI', name: 'PI' },
        { value: 'RJ', name: 'RJ' },
        { value: 'RN', name: 'RN' },
        { value: 'RS', name: 'RS' },
        { value: 'RO', name: 'RO' },
        { value: 'RR', name: 'RR' },
        { value: 'SC', name: 'SC' },
        { value: 'SP', name: 'SP' },
        { value: 'SE', name: 'SE' },
        { value: 'TO', name: 'TO' },
      ],
    },
    links: {
      test: {
        domain: 'https://test-online.wiseup.com',
        firstAccess:
          'https://test-online.wiseup.com/set-password?token=${token}&mode=CONFIRMATION&origin=checkout',
        terms: 'https://test.wiseup.com/pt/online/termos-de-servico/',
        politics: 'https://wiseup.com/politica-de-privacidade/',
      },
      homolog: {
        domain: 'https://online.wiseup.com',
        firstAccess:
          'https://online.wiseup.com/set-password?token=${token}&mode=CONFIRMATION&origin=checkout',
        terms: 'https://wiseup.com/pt/online/termos-de-servico/',
        politics: 'https://wiseup.com/politica-de-privacidade/',
      },
      production: {
        domain: 'https://online.wiseup.com',
        firstAccess:
          'https://online.wiseup.com/set-password?token=${token}&mode=CONFIRMATION&origin=checkout',
        terms: 'https://wiseup.com/pt/online/termos-de-servico/',
        politics: 'https://wiseup.com/politica-de-privacidade/',
      },
    },
  },

  style: {
    form: {
      maxWidth: '465px',
    },
    backgroundColor: '#180a29',
    backgroundGradient: '#2C1D3E',
    ribbonColor: '#00eb84',
    invoiceDetails: {
      borderColor: '#180a29',
      divisorColor: '#180a29',
    },
    link: {
      color: '#00eb84',
      bgColor: '#271042',
    },
    pix: {
      backgroundColor: '#2a004f',
      backgroundColorLogo: '#fff',
      buttonColor: '#00eb84',
    },
    text: {
      color: '#fff',
      subColor: '#00eb84',
      descriptionColor: '#bcbcbc',
      fontFamily: "'Nunito Sans', sans-serif",
      title: {
        fontSize: '20px',
        lineHeight: '25px',
      },
      subtitle: {
        fontSize: '14px',
        lineHeight: '25px',
      },
      body: {
        fontSize: '14px',
        lineHeight: '16px',
      },
    },
    fontFamily: "'Nunito Sans', sans-serif",
    sellerBox: {
      backgroundColor: '#00eb84',
      color: '#2a004f',
    },
    buttons: {
      webkitAppearance: 'none',
      mozAppearance: 'none',
      appearance: 'none',
      webkitBorderRadius: '20px',
      khtmlBorderRadius: '20px',
      mozBorderRadius: '20px',
      msBorderRadius: '20px',
      oBorderRadius: '20px',
      borderRadius: '20px',
      backgroundColor: '#00eb84',
      fontSize: '14px',
      fontWeight: 'bold',
      textAlign: 'center',
      color: '#2a004f',
      height: '60px',
      display: 'block',
      border: 'none',
      fontFamily: "'Nunito Sans', sans-serif",
      cursor: 'pointer',
      margin: '20px auto 50px',
      width: '100%',
      textTransform: 'uppercase',
      lineHeight: '1.57',
      letterSpacing: '1.4px',
    },
    input: {
      width: '100%',
      border: 'none',
      borderBottom: 'solid 1px #404040',
      borderRadius: '0',
      backgroundColor: 'transparent',
      fontSize: '14px',
      fontWeight: 'normal',
      boxShadow: 'none',
      color: '#fff',
      fontFamily: '"Nunito Sans", sans-serif',
      // transition: 'all .3s ease-in-out', // temporario
      transition: 'none',
      padding: '30px 10px 0px',
      height: '70px',
      boxSizing: 'border-box',
      active: {
        color: '#180a29',
      },
      code: {
        borderBottom: 'solid 1px #404040',
        height: 'auto !important',
      },
      valid: {
        borderBottom: 'solid 1px #00eb84 !important',
        border: 'none',
        boxShadow: 'none',
        boxShadowColor: 'none',
      },
      invalid: {
        borderBottom: 'solid 1px #cb0000 !important',
        border: 'none',
        boxShadow: 'none',
        boxShadowColor: 'none',
      },
      focus: {
        borderBottom: 'solid 1px #fff !important',
        height: '70px',
        borderRadius: '20px',
        boxShadow: '0 7px 11px 0 rgba(0,0,0,.09)',
        backgroundColor: '#fff',
        border: '0',
        color: '#404040',
        outline: 'none',
      },
      outlined: {
        borderBottom: 'none',
        border: 'none',
        outline: 'none',
      },
      autofill: {
        border: 'none',
        webkitTextFillColor: '#fff!important',
        backgroundColor: '#180a29!important',
        webkitBoxShadow: '0 0 0 100px #180a29 inset!important',
        transition: 'background-color 5000s ease-in-out 0s',
        borderRadius: '0',
      },
    },
    select: {
      width: '100%',
      border: '0',
      borderBottom: 'solid 1px #404040',
      backgroundColor: 'transparent',
      fontSize: '14px',
      fontWeight: 'normal',
      boxShadow: 'none',
      color: '#fff',
      fontFamily: "'Nunito Sans',sans-serif",
      transition: 'none',
      height: '70px',
      padding: '30px 10px 0px',
      appearance: 'none',
      webkitAppearance: 'none',
      mozAppearance: 'none',
      borderRadius: '0',
      webkitBorderRadius: '0',
      khtmlBorderRadius: '0',
      mozBorderRadius: '0',
      msBorderRadius: '0',
      focus: {
        outline: 'none',
      },
      placeholder: {
        fontFamily: "'Nunito Sans', sans-serif",
        textTransform: 'none',
      },
      autofill: {
        borderBottom: 'solid 1px #fe7000!important',
        backgroundColor: '#000!important',
        transition: 'background-color 5000s ease-in-out 0s',
        webkitTextFillColor: '#fff!important',
        webkitBoxShadow: 'none',
        boxShadow: 'none',
      },
      errorMsg: {
        fontSize: '13px',
        display: 'block',
        maxWidth: '375px',
        color: '#cb0000',
        margin: '0 0 -.6vh',
        padding: '1.5vh 10px 0',
        position: 'relative',
      },
    },
    fieldWrapper: {
      position: 'relative',
      paddingBottom: '3vh',
      width: '100%',
      textAlign: 'left',
    },
    fieldLabel: {
      fontWeight: 600,
      position: 'absolute',
      color: '#ffffff',
      top: '11px',
      left: '10px',
      letterSpacing: 'normal',
      // transition: 'all 0.3s ease-in-out 0s', // temporario
      transition: 'none',
      fontSize: '14px',
      fontFamily: "'Nunito Sans', sans-serif",
      zIndex: 9,
      active: {
        color: '#180a29',
      },
    },
    lead: {
      formTitle: {
        fontFamily: "'Nunito Sans', sans-serif",
        fontWeight: 'normal',
        fontSize: '20px',
        textAlign: 'center',
        lineHeight: 'normal',
        color: '#ffffff',
        marginBottom: '30px',
      },
      formSubtitle: {
        fontFamily: "'Nunito Sans', sans-serif",
        fontWeight: 'normal',
        fontSize: '20px',
        textAlign: 'center',
        color: '#ffffff',
      },
      checkboxPolitica: {
        boxCheckPolitica: {
          margin: '15px 0 35px 0',
        },
        textBoxPolitica: {
          color: '#FFFFFF',
          colorLink: '#00EC84',
        },
        checkmarkPolitica: {
          border: '2px solid #FFFFFF',
          backgroundColor: '#00EB84',
        },
      },
    },
    payment: {
      formTitle: {
        fontFamily: "'Nunito Sans', sans-serif",
        fontWeight: 'normal',
        fontSize: '20px',
        textAlign: 'center',
        lineHeight: 'normal',
        color: '#ffffff',
        marginBottom: '30px',
      },
      formSubtitle: {
        fontFamily: "'Nunito Sans', sans-serif",
        fontWeight: 'normal',
        fontSize: '20px',
        textAlign: 'center',
        color: '#ffffff',
      },
      formText: {
        fontFamily: "'Nunito Sans', sans-serif",
        fontWeight: 'normal',
        fontSize: '14px',
        textAlign: 'center',
        color: '#9e9e9e',
        width: '84%',
        margin: '0 auto 40px',
      },
    },
    error: {
      formErrorMsg: {
        margin: '20px 0',
        fontSize: '14px',
        paddingTop: '2px',
        display: 'block',
        color: '#cb0000',
        textAlign: 'center',
      },
      errorMsg: {
        fontSize: '13px',
        display: 'block',
        maxWidth: '375px',
        color: '#cb0000',
        margin: '0 0 -.6vh',
        padding: '1.5vh 10px 0',
        position: 'relative',
      },
    },
    steps: {
      display: 'block',
      color: '#9E9E9E',
      checkColor: '#180a29',
      borderColor: '#00eb84',
      backgroundColor: '#180a29',
    },
    success: {
      maxWidth: '400px',
      containerSuccess: {
        marginTop: '10px',
        width: '100%',
      },
      boxSuccess: {
        maxWidth: '300px',
        paddingLeft: '0',
        paddingRight: '0',
      },
      background: {
        paddingTop: '10px',
        display: 'block',
        image: 'success-back.svg',
        position: '50% 40%',
      },
      title: {
        fontSize: '32px',
        lineHeight: '50px',
        fontFamily: "'Nunito Sans', sans-serif",
        width: 'auto',
        margin: '100px auto 0',
        fontWeight: 'bold',
      },
      text: {
        lineHeight: '18px',
        fontSize: '14px',
        color: '#fff',
        width: '275px',
        margin: '0 auto 60px',
        fontStyle: 'normal',
        fontWeight: '400',
        textAlign: 'center',
      },
      terms: {
        color: '#9E9E9E',
        fontSize: '12px',
        margin: '20px 0',
        display: 'none',
        width: '100%',
        link: {
          color: '#f16522',
          textDecoration: 'none',
        },
      },
      button: {
        width: '100%',
        textTransform: 'uppercase',
        letterSpacing: '1.4px',
        fontSize: '14px',
      },
    },
    successBoleto: {
      maxWidth: '400px',
      background: {
        paddingTop: '10px',
        display: 'block',
        image: 'success-back.svg',
        position: '26px 16px',
      },
      title: {
        fontSize: '32px',
        lineHeight: '67px',
        width: 'auto',
        margin: '45px auto 0',
        fontWeight: '600',
      },
      text: {
        lineHeight: '18px',
        fontSize: '16px',
        color: '#fff',
        width: '275px',
        margin: '10px auto 20px',
        display: 'block',
        fontStyle: 'normal',
        fontWeight: '400',
        textAlign: 'center',
      },
      terms: {
        color: '#9E9E9E',
        fontSize: '12px',
        margin: '20px 0',
        display: 'none',
        width: '100%',
        link: {
          color: '#f16522',
          textDecoration: 'none',
        },
      },
    },
    paymentMethod: {
      float: 'left',
      width: '100%',
      border: '1px solid #00eb84',
      marginBottom: '30px',
      borderRadius: '20px',
      paddingBottom: '10px',
      boxTitle: {
        float: 'left',
        width: '100%',
        cursor: 'pointer',
        boxSelection: {
          float: 'left',
          width: '16%',
          textAlign: 'center',
          ballSelection: {
            display: 'inline-block',
            marginTop: '20px',
            width: '17px',
            height: '17px',
            border: '1px solid #00eb84',
            borderRadius: '100%',
          },
        },
        titlePaymentMethod: {
          float: 'left',
          width: '84%',
          title_1: {
            margin: '16px 0 0 0',
            fontFamily: "'Nunito Sans', sans-serif",
            fontWeight: 'bold',
            textAlign: 'left',
            fontSize: '18px',
            color: '#fff',
            lineHeight: '25px',
          },
          title_2: {
            margin: '0 0 0 0',
            fontFamily: "'Nunito Sans', sans-serif",
            fontWeight: 'bold',
            fontSize: '14px',
            color: '#00eb84',
            lineHeight: '25px',
          },
        },
      },
      contentPaymentMethod: {
        float: 'left',
        width: '81%',
        paddingLeft: '14%',
        paddingRight: '5%',
        display: 'none',
        title_1: {
          margin: '4px 0 8px 10px',
          opacity: '0.5',
          color: '#fff',
          fontSize: '14px',
          textAlign: 'left',
          fontWeight: 'bold',
        },
      },
      active: {
        backgroundColor: '#2a004f',
        border: '0',
        boxTitle: {
          boxSelection: {
            ballSelection: {
              background: '#00eb84',
            },
          },
        },
        contentPaymentMethod: {
          display: 'block',
        },
      },
    },
    parsing: {
      maxWidth: '286px',
      background: {
        paddingTop: '10px',
        display: 'block',
        image: 'success-back.svg',
        position: 'top',
      },
      title: {
        fontSize: '32px',
        lineHeight: '67px',
        width: 'auto',
        margin: '30px auto 0',
        fontWeight: '600',
      },
      text: {
        lineHeight: '18px',
        fontSize: '16px',
        color: '#fff',
        width: '275px',
        margin: '0 auto 60px',
        fontStyle: 'normal',
        fontWeight: '400',
        textAlign: 'center',
      },
    },
    terms: {
      color: '#ffffff',
      fontSize: '12px',
      margin: '3vh 0 5vh',
      display: 'block',
      width: '100%',
      textTransform: 'uppercase',
      textAlign: 'center',
      letterSpacing: '2px',
      link: {
        color: '#00eb84',
        textDecoration: 'none',
      },
    },
    assets: {
      logo: {
        file: 'logo-wup.svg',
        width: '153px',
      },
      favicon: 'favicon-wol.ico',
      loading: 'rolling-wp.svg',
      backgroundLoading: '#180a29e6',
    },
  },

  text: {
    sellerBox: 'Atendimento realizado por',
    pix: 'Para efetuar o pagamento pelo pix, siga o passo a passo abaixo. Após o processamento do pagamento, você receberá um  e-mail com a confirmação do valor total de sua assinatura anual, de {CYCLEPRICE}',
    error: {
      general:
        'Ocorreu um erro inesperado, por gentileza tente novamente mais tarde',
      payment:
        'Não conseguimos processar a transação. Faça uma nova tentativa.',
    },
    lead: {
      title: '',
      text: 'Crie sua Conta',
      button: 'Continuar',
      toco: {
        title: '',
        text: 'Crie sua Conta',
      },
      labels: {
        name: 'Nome Completo',
        email: 'E-mail',
        phone: 'Celular',
      },
      placeholder: {
        name: 'Ex: João Silva',
        email: 'Ex: seuemail@gmail.com',
        phone: 'Ex: 41999999999',
      },
    },
    blackFriday: {
      title: 'Falta pouco pra você começar a estudar',
      text: '<br />Aproveite o voucher de R$120,00 da Black November na sua assinatura anual e comece a estudar agora mesmo.',
      pretext:
        '<br />Assim que você confirmar esta etapa, sua assinatura anual será ativada e você terá acesso a todo conteúdo do Wise Up Online. Aproveite o voucher de R$120,00 da Black November na sua assinatura anual e comece a estudar agora mesmo.',
      price: '',
      postext: '',
    },
    trial: {
      title: 'Falta pouco pra você começar a estudar',
      text: 'Assim que você confirmar esta etapa, sua assinatura anual será ativada e você terá acesso a todo conteúdo do Wise Up Online.',
      pretext:
        'Assim que você confirmar esta etapa, sua assinatura anual será ativada e você terá acesso a todo conteúdo do Wise Up Online.',
      price: '',
      postext: '',
    },

    paymentWtp: {
      title: 'Insira os dados do cartão de crédito',
    },

    payment: {
      bankslip: {
        title: 'Falta pouco pra você começar a estudar.',
        description:
          'Seu boleto será emitido na próxima etapa, assim que enviar seus dados. Após o pagamento, sua assinatura anual será ativada garantindo acesso a todo conteúdo do Wise Up Online.',
        BLACKFRIDAY: {
          text: 'Aproveite o voucher de R$120,00 da Black November na sua assinatura anual e comece a estudar agora mesmo.',
        },
        DEZOFF: {
          text: 'Aproveite o voucher de R$120,00 da Black November na sua assinatura anual e comece a estudar agora mesmo.',
        },
      },
      title: 'Falta pouco pra você começar a estudar.',
      text: 'Assim que você confirmar esta etapa, sua assinatura anual será ativada e você terá acesso a todo conteúdo do Wise Up Online.',
      pretext:
        'Assim que você confirmar esta etapa, sua assinatura anual será ativada, com a cobrança de 12 parcelas de {CYCLEPRICE} e você terá acesso a todo conteúdo do Wise Up Online.',
      price: '',
      postext: '',
      button: 'Finalizar',
      buttonCardStep: 'Continuar',
      payWith: 'Pagar com ',
      address: 'Endereço de Cobrança',
      labels: {
        cardCompany: 'Selecione sua bandeira',
        cardName: 'Nome do titular',
        cardNumber: 'Número do cartão',
        cardExpireDate: 'Data de validade',
        cardCVV: 'CVV',
        postalCode: 'CEP',
        addressLine1: 'Rua',
        addressLine2: 'Número',
        addressLine3: 'Complemento',
        city: 'Cidade',
        state: 'Estado',
        country: 'País',
      },
      placeholder: {
        cardCompany: 'Selecione',
        cardName: 'Ex: João Silva',
        cardNumber: '**** **** **** ****',
        cardExpireDate: 'MM/AA',
        cardCVV: 'xxx',
        postalCode: 'xxxxx xxxx',
        addressLine1: 'xxxxx',
        addressLine2: 'xxxxx',
        addressLine3: 'xxxxx',
        city: 'Cidade',
        state: 'Estado',
        country: 'País',
      },
      errorMessage: {
        cardCompany: 'Selecione a bandeira do cartão',
      },
    },
    payment3m: {
      title:
        'Falta pouco para liberar seus 3 meses grátis. Informe o seu cartão para ter acesso',
      text: 'Sua assinatura será ativada automaticamente após este período, com a cobrança em 12 parcelas de {CYCLEPRICE}.',
      pretext:
        'Sua assinatura será ativada automaticamente após este período. A cobrança será de',
      price: '',
      postext:
        'Caso não queira se tornar aluno, antes do fim do período grátis faça sua solicitação em nosso site e seu cancelamento será realizado automaticamente.',
      button: 'Finalizar',
      labels: {
        cardCompany: 'Selecione sua bandeira',
        cardName: 'Nome do titular',
        cardNumber: 'Número do cartão',
        cardExpireDate: 'Data de validade',
        cardCVV: 'CVV',
        postalCode: 'CEP',
        addressLine1: 'Rua',
        addressLine2: 'Número',
        addressLine3: 'Complemento',
        city: 'Cidade',
        state: 'Estado',
        country: 'País',
      },
      placeholder: {
        cardCompany: 'Selecione',
        cardName: 'Ex: João Silva',
        cardNumber: '**** **** **** ****',
        cardExpireDate: 'MM/AA',
        cardCVV: 'xxx',
        postalCode: 'xxxxx xxxx',
        addressLine1: 'xxxxx',
        addressLine2: 'xxxxx',
        addressLine3: 'xxxxx',
        city: 'Cidade',
        state: 'Estado',
        country: 'País',
      },
      errorMessage: {
        cardCompany: 'Selecione a bandeira do cartão',
      },
    },
    success: {
      title: 'Parabéns',
      text: 'Você realizou a sua assinatura',
      button: 'Seguir para configuração de senha',
    },
    successBoleto: {
      title: 'Quase lá',
      text1:
        'Seu boleto será registrado no banco e estará disponível para pagamento em até 2 horas. Você pode acessá-lo abaixo.',
      text2:
        'Em até 2 dias após a confirmação de pagamento, seu acesso será enviado ao seu e-mail.',
      button: 'Ver boleto',
    },
  },
} as const;
